import { gql } from '@apollo/client';
import { MockedResponse } from '@apollo/client/testing';
import { MOCK_CLIENT_ID } from '.';
type FeatureFlagFragment = {
  __typename?: 'FeatureFlag';
  name: string;
  enabled: boolean;
};
export type FeatureFlagsResponse = {
  __typename?: 'Query';
  client: {
    __typename?: 'Client';
    id: string;
    featureFlags: FeatureFlagFragment[];
  };
};
const featureFlagsMock: FeatureFlagFragment[] = [{
  __typename: 'FeatureFlag',
  name: 'client.feedback_thumbs_enabled',
  enabled: true
}, {
  __typename: 'FeatureFlag',
  name: 'client.shop.browse_page_enabled',
  enabled: true
}];
export const getFeatureFlagsResponseMock: FeatureFlagsResponse = {
  __typename: 'Query',
  client: {
    __typename: 'Client',
    id: MOCK_CLIENT_ID || '1234',
    featureFlags: featureFlagsMock
  }
};
export const GetFeatureFlagsDocument = gql`
  query getFeatureFlags(
    $flags: [FeatureFlagInput!]!
    $includeClient: Boolean!
    $includeVisitor: Boolean!
  ) {
    client @include(if: $includeClient) {
      id
      featureFlags(input: $flags) {
        name
        enabled
        __typename
      }
      __typename
    }
    visitor @include(if: $includeVisitor) {
      id
      featureFlags(input: $flags) {
        name
        enabled
        __typename
      }
      __typename
    }
  }
`;
type GetFeatureFlagsVariables = {
  flags: {
    name: string;
  }[];
  includeClient: boolean;
  includeVisitor: boolean;
};
type FeatureFlagsData = {
  __typename: 'Query';
  client: {
    __typename: 'Client';
    id: string;
    featureFlags: {
      __typename: 'FeatureFlag';
      name: string;
      enabled: boolean;
    }[];
  } | null;
  visitor?: {
    __typename: 'Visitor';
    id: string;
    featureFlags: {
      __typename: 'FeatureFlag';
      name: string;
      enabled: boolean;
    }[];
  } | null;
};
export const SEE_IT_ON_ME_ZOOM_FEATURE_FLAG = 'client.web.vision_see_it_on_me_zoom';
export const getFeatureFlagsApolloMock = ({
  enabled = true,
  includeClient = true,
  includeVisitor = false,
  clientId = '1234',
  flagName = 'client.feedback_thumbs_enabled',
  flagNames,
  enabledByFlag,
  maxUsageCount
}: Partial<{
  enabled: boolean;
  includeClient: boolean;
  includeVisitor: boolean;
  clientId: string;
  flagName: string;
  flagNames: string[];
  enabledByFlag: Record<string, boolean>;
  maxUsageCount: number;
}> = {}): MockedResponse<FeatureFlagsData> => {
  const flags = flagNames ?? [flagName];
  const featureFlags = flags.map(name => ({
    __typename: 'FeatureFlag' as const,
    name,
    enabled: enabledByFlag?.[name] ?? enabled
  }));
  return {
    request: {
      query: GetFeatureFlagsDocument,
      variables: {
        flags: flags.map(name => ({
          name
        })),
        includeClient,
        includeVisitor
      } as GetFeatureFlagsVariables
    },
    ...(maxUsageCount !== undefined ? {
      maxUsageCount
    } : {}),
    result: {
      data: {
        __typename: 'Query',
        client: includeClient ? {
          __typename: 'Client',
          id: clientId,
          featureFlags
        } : null,
        visitor: includeVisitor ? {
          __typename: 'Visitor',
          id: 'visitor-1',
          featureFlags
        } : null
      }
    }
  };
};

/** Reusable mock for OutfitsCarousel's SIOM zoom flag query. */
export const seeItOnMeZoomFeatureFlagMock = getFeatureFlagsApolloMock({
  flagName: SEE_IT_ON_ME_ZOOM_FEATURE_FLAG,
  enabled: false,
  maxUsageCount: Number.POSITIVE_INFINITY
});